import { render, staticRenderFns } from "./werkForm.vue?vue&type=template&id=7f737ac0&scoped=true"
import script from "./werkForm.vue?vue&type=script&lang=js"
export * from "./werkForm.vue?vue&type=script&lang=js"
import style0 from "./werkForm.vue?vue&type=style&index=0&id=7f737ac0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f737ac0",
  null
  
)

export default component.exports